// eslint-disable-next-line no-use-before-define
import { useMutation, useQuery } from '@apollo/client';
import { Fragment, PropsWithChildren, useContext, useEffect, useState } from 'react';

import { Box } from '@mui/material';
import classNames from 'classnames';
import { HeaderBar } from 'op-components';
import { UserContext } from 'op-contexts';
import { RoleType } from 'op-enums';
import { GET_RECENT_PATIENTS, GET_USER_PROFILE } from 'op-graphql/queries';
import { isDemo } from 'op-utils';

import { SET_USER_SURVEY } from './queries';

import './Base.scss';

const { RO, MO, REGISTRAR } = RoleType;

const REACT_APP_REGION = import.meta.env.REACT_APP_REGION;

const ROBase = ({ children }: PropsWithChildren): JSX.Element => {
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const {
    state: { navShow, panelShow, primaryRole },
  } = useContext(UserContext);

  const { data: patientData } = useQuery(GET_RECENT_PATIENTS, {
    fetchPolicy: 'network-only',
    skip: ![RO, MO, REGISTRAR].includes(primaryRole),
  });
  const recentPatients = patientData && patientData.getRecentPatients ? patientData.getRecentPatients : [];

  const { data: userData } = useQuery(GET_USER_PROFILE);
  const [setUserSurvey] = useMutation(SET_USER_SURVEY);

  useEffect(() => {
    if (isDemo || !userData || !userData.user) return;
    const user = userData.user;

    (function initializeSurvicate(w) {
      const script = document.createElement('script');
      script.src = 'https://survey.survicate.com/workspaces/72ec103d56c4e992c84711e666197859/web_surveys.js';
      script.async = true;

      script.onload = () => {
        const interval = setInterval(() => {
          if (window._sva) {
            window._sva.setVisitorTraits({
              user_id: user.id,
              surveys_displayed: user.surveysDisplayed?.join(', ') || '',
              name: user.name || '',
              primary_role: user.primaryRole || '',
              state: user.state || '',
              is_ro: user.isRo,
              region: REACT_APP_REGION || '',
              is_prod: user.isProd,
            });

            if (!window._svaAddedListeners) {
              window._svaAddedListeners = new Set();
            }

            if (!window._svaAddedListeners.has('survey_displayed')) {
              window._sva.addEventListener('survey_displayed', function (surveyId: any) {
                setUserSurvey({
                  variables: { surveyId },
                });
              });
            }

            window._svaAddedListeners.add('survey_displayed');

            clearInterval(interval);
          }
        }, 1000);

        setTimeout(() => clearInterval(interval), 10000);
      };

      const element = document.getElementsByTagName('script')[0];
      if (element && element.parentNode) {
        element.parentNode.insertBefore(script, element);
      }
    })(window);
  }, [userData]);

  const toggleSearchModal = () => {
    setIsSearchVisible(!isSearchVisible);
  };

  return (
    <Box
      className={classNames('ro-container', {
        'has-side-nav-active': navShow,
        'has-side-nav-inactive': !navShow,
        'has-side-panel-active': panelShow,
        'has-side-panel-inactive': !panelShow,
      })}
      id="ROContainer">
      <Fragment>
        <HeaderBar toggleSearchModal={toggleSearchModal} recentPatients={recentPatients} styledProps={true} />
        {children}
      </Fragment>
    </Box>
  );
};

export default ROBase;
